import React from "react";
import UserActions from "lib/userActions";
import Grid from "@material-ui/core/Grid";
import {
    DropDown,
    DropItem,
    MediumPrimaryButton,
    MediumLinkButton,
    SuccessAlert,
} from "@worthy-npm/clarity";
import I18n from "lib/i18n/i18n";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    addAnotherPiece,
    getItem,
    acceptItemEstimation,
    delayedItemUpdate,
} from "actions/item";
import { appointmentsItemDetails } from "actions/user";
import {
    isMobile,
    rootUrl,
    STEP_PICKUP,
    STEP_PHONE,
    SHIPPING,
    PICKUP_WAITING,
    dataAutomationAttr,
    imageUrl,
    VALIDATION_NEEDED,
    SHIPMENT_METHOD,
} from "helpers/ApplicationHelper";

import ExtraInfo from "./extraInfo";
import ListingSkeleton from "../listing/listingSkeleton";
import ItemDetails from "./itemDetails";
import UpNext from "./upNext";
import ShipmentInformation from "../listing/shipmentInformation";
import _ from "lodash";
import WorthyApiErrors from "lib/api/worthyApiErrors";
import NoMatch from "../noMatch";
import Login from "../login";
import ExtraInfoMobileSlider from "./slider/extraInfoMobileSlider";
import { PopupListing } from "../popups/popupListing";
import ListingAlerts from "../listing/listingAlerts";
import ScheduleShipmentModalPopup from "../popups/scheduleShipmentModalPopup";
import Intercom from "lib/intercom";
import { ItemTypesPlural } from "../../constants/itemDetails";
import AdditionalItemDetails from "./additionalItemDetails";
import BlackBox from "./blackBox";
import CertificateAlert from "./CertificateAlert";
import GA from "lib/ga";

class LightListing extends React.Component {
    constructor(props) {
        super(props);
        this.isMobile = isMobile();
        props.getItem(this.props.params.itemId);
        this.state = {
            showAddingAnotherPieceForm: false,
            prevObserverYPosition: 0,
            openCompleteAccountModal: false,
            itemToBeAddedType: ItemTypesPlural.Ring,
            certificateUpdateAlert: null, // success | error
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { ADO, item, Session, P13N } = props;

        if (ADO && item && Session) {
            if (!LightListing.version) {
                LightListing.setVersion(props);
                UserActions.lightListingPage(
                    "Light Listing page presented",
                    item.id,
                    LightListing.version
                );

                if (ADO.intercomDataEvent) {
                    Intercom.updateContactData(
                        JSON.parse(ADO.intercomDataEvent)
                    );
                }
            }
        }

        return state;
    }

    logAction = (message, { itemId, version }) => {
        UserActions.lightListingPage(
            message,
            itemId || this.props.item.id,
            version || LightListing.getVersion(this.props)
        );
    };

    static goTo = (
        siteLink,
        message,
        itemId,
        noRootUrl = false,
        stopAnimation
    ) => {
        if (stopAnimation) {
            stopAnimation();
        }
        UserActions.lightListingPage(message, itemId, LightListing.version);

        window.open(
            noRootUrl ? siteLink : `${rootUrl(siteLink)}`,
            isMobile() ? "_self" : "_blank"
        );
    };

    static getVersion() {
        LightListing.number = "2";
        return I18n.getString(
            `listingPageLight::versions::v${LightListing.number}`
        );
    }

    static setVersion(props) {
        LightListing.version = this.getVersion(props);
    }

    openSSSForMobile = (itemId, step) => {
        this.setState({ openSchedulePickupForm: true, step });
    };

    openDesktopPopup = (slide, props) => {
        this.state["slide"] = slide;
        const s = ExtraInfoMobileSlider.getSlide({ state: { slide }, props });

        PopupListing.initPopup({
            classNames: ["listing-popup-light", "no-animation", slide["slug"]],
            title: s.title,
            content: s.content,
            superDangerous: true,
        });
    };

    // FIXME: SK is disabled for Light Listing temporarily
    renderShipmentInformation = (item) => {
        return (
            <ShipmentInformation
                openSchedulePickupFormForMobile={this.openSSSForMobile}
                logger={this.logAction}
                item={item}
                editable={true}
                showTitle={false}
                isSKExperiment={false}
                version={LightListing.getVersion(this.props)}
            />
        );
    };

    openExtraInfoSlider = (slide, item, version) => {
        if (this.isMobile) {
            this.setState({ openSlide: slide });
        } else {
            this.openDesktopPopup(slide, { item, version });
        }
    };

    closeExtraInfoSlider = () => {
        this.setState({ openSlide: null });
    };

    shouldOpenCompleteAccountModal = (shouldOpen) => {
        this.setState({ openCompleteAccountModal: shouldOpen });
    };

    componentDidMount() {
        this.updateDate("", false);
    }

    componentDidUpdate() {
        const { item } = this.props;

        if (item instanceof WorthyApiErrors && item.hasError(404)) {
            return;
        }
    }

    openSSSForDesktop = () => {
        const { item, version } = this.props;
        ScheduleShipmentModalPopup.initPopup({
            step: item.shipment ? STEP_PICKUP : STEP_PHONE,
            version,
            itemId: item.id,
        });
    };

    closeOnEscape = (e) => {
        if (e.keyCode === 27) {
            this.toggleAddingAnotherPiece(false);
        }
    };

    toggleAddingAnotherPiece = (value) => {
        if (!this.isMobile) {
            document.body[value ? "addEventListener" : "removeEventListener"](
                "keydown",
                this.closeOnEscape
            );
        }
        this.setState({ showAddingAnotherPieceForm: value });
    };

    addAnotherPieceExpAdding = () => {
        this.setState({ addInProgress: true });
        const { item, addAnotherPiece } = this.props;
        const { itemToBeAddedType } = this.state;
        return addAnotherPiece(item.id, itemToBeAddedType).then((data) => {
            this.toggleAddingAnotherPiece(false);
            UserActions.lightListingPage(
                `${itemToBeAddedType} added to bundle`,
                item.id,
                LightListing.version
            );
            this.setState({
                addInProgress: false,
                itemToBeAddedType: ItemTypesPlural.Ring,
            });
        });
    };

    addAnotherPieceExpCancelling = (e) => {
        e.preventDefault();
        this.setState({
            showAddingAnotherPieceForm: false,
        });
    };

    getItemInfo = () => {
        this.props.getItem(this.props.params.itemId, false, {}, true);
    };

    updateItemAutoGrate = () => {
        const { item, updateItem } = this.props;

        updateItem(item, "desc");
    };

    updateDate = (eventId, isCalendly = true) => {
        if (!isCalendly) {
            this.props.appointmentsItemDetails("", this.props.params.itemId);
            return;
        }

        if (eventId) {
            this.props.appointmentsItemDetails(
                eventId,
                this.props.params.itemId
            );
        }
    };

    render() {
        const { Session, item, getItem, appointment, ADO } = this.props;

        const {
            openSchedulePickupForm,
            openSlide,
            step,
            openCompleteAccountModal,
        } = this.state;

        const {
            requestingNewItem,
            showAddingAnotherPieceForm,
            addInProgress,
            itemToBeAddedType,
            certificateUpdateAlert,
        } = this.state;

        const LOGGED_IN = Session && Session.isLoggedIn;

        if (item instanceof WorthyApiErrors && item.hasError(404)) {
            if (LOGGED_IN) {
                return requestingNewItem ? <ListingSkeleton /> : <NoMatch />;
            } else
                return (
                    <Login
                        showLinkToRegister={true}
                        onSubmitForm={() => {
                            this.setState({ requestingNewItem: true });
                        }}
                        onLoginSuccessful={() => {
                            getItem(
                                this.props.params.itemId,
                                false,
                                this.props.location.query
                            ).then(() => {
                                this.setState({ requestingNewItem: true });
                            });
                        }}
                    />
                );
        } else if (item && item.properties) {
            const version = LightListing.getVersion(this.props);

            const ITEM_DETAILS_SECTION = (
                <ItemDetails
                    logger={this.logAction}
                    clickOnBox={this.openExtraInfoSlider}
                    item={item}
                    version={version}
                    onDataChange={() => this.getItemInfo()}
                    onCertificateUpdate={this.updateItemAutoGrate}
                    showCertificateAlert={(variant) => {
                        this.setState({ certificateUpdateAlert: variant });
                    }}
                />
            );

            const UP_NEXT_SECTION = (
                <UpNext
                    version={version}
                    step={step}
                    dateChanged={this.updateDate}
                    appointment={appointment}
                    openSchedulePickupFormByProp={openSchedulePickupForm}
                    onSSSFClose={() => {
                        this.setState({ openSchedulePickupForm: false });
                    }}
                />
            );

            let ADDITIONAL_ITEMS =
                item.additional_items &&
                item.additional_items.sort((a, b) => {
                    if (a.submit_timestamp < b.submit_timestamp) {
                        return -1;
                    }
                    if (a.submit_timestamp > b.submit_timestamp) {
                        return 1;
                    }
                    return 0;
                });
            let ADD_ANOTHER_PIECE;
            if (this.isMobile) {
                ADD_ANOTHER_PIECE = (
                    <>
                        {!hideAddAnotherPieceButton &&
                            ADDING_ANOTHER_PIECE_BUTTON}
                        {showAddingAnotherPieceForm && (
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                }}
                                className={`another-piece-form another-piece-form-mobile pos-rel ${
                                    addInProgress && "disabled"
                                }`}
                            >
                                <span className="item-upper-caption item-upper-caption-temp">
                                    #--
                                </span>
                                {ADDING_ANOTHER_PIECE_DROPDOWN}
                                {itemToBeAddedType && (
                                    <div className="submit-clarity-button-wrapper">
                                        <MediumPrimaryButton
                                            text={I18n.getString(
                                                "listingPageLight::itemDetails::add"
                                            )}
                                            click={
                                                this.addAnotherPieceExpAdding
                                            }
                                        />
                                    </div>
                                )}
                                {itemToBeAddedType && (
                                    <div className="submit-clarity-button-wrapper">
                                        <MediumLinkButton
                                            text={I18n.getString(
                                                "listingPageLight::itemDetails::cancel"
                                            )}
                                            overrideWrapperCSS={{
                                                marginLeft: "12px",
                                            }}
                                            click={
                                                this
                                                    .addAnotherPieceExpCancelling
                                            }
                                        />
                                    </div>
                                )}
                            </form>
                        )}
                    </>
                );
            }

            let COMPONENTS_FLOW_MOBILE = [
                <>
                    <Grid
                        key="item-detail-section-mobile"
                        className={`light-listing`}
                        container
                        spacing={0}
                    >
                        {ITEM_DETAILS_SECTION}
                    </Grid>
                    {ADDITIONAL_ITEMS && ADDITIONAL_ITEMS.length > 0 && (
                        <Grid
                            className={`light-listing secondary-items-list`}
                            container
                            spacing={0}
                            key="secondary-items-list-mobile"
                        >
                            {ADDITIONAL_ITEMS.map((i) => {
                                return (
                                    <AdditionalItemDetails
                                        key={`addition-item-${i.id}`}
                                        logger={this.logAction}
                                        clickOnBox={
                                            item.workflow_state === SHIPPING
                                                ? () => {}
                                                : this.openExtraInfoSlider
                                        }
                                        item={i}
                                        parentItemId={
                                            this.props.params?.itemId
                                                ? this.props.params?.itemId
                                                : window.location.pathname.replace(
                                                      /\D/g,
                                                      ""
                                                  )
                                        }
                                        version={version}
                                        onDataChange={() => this.getItemInfo()}
                                    />
                                );
                            })}
                        </Grid>
                    )}
                </>,
                <Grid
                    className={`light-listing`}
                    container
                    spacing={0}
                    key="up-next-section-mobile"
                >
                    {UP_NEXT_SECTION}
                </Grid>,
            ];

            let ADDING_ANOTHER_PIECE_BUTTON;
            let ADDING_ANOTHER_PIECE_DROPDOWN;
            let hideAddAnotherPieceButton =
                item.workflow_state === SHIPPING &&
                item.bundle.workflow_state === PICKUP_WAITING;

            ADDING_ANOTHER_PIECE_BUTTON = (
                <button
                    className={`add-another-piece c-pointer w-100 text-left ${
                        showAddingAnotherPieceForm && "hidden"
                    }`}
                    onClick={() => {
                        UserActions.lightListingPage(
                            "Add item clicked",
                            item.id,
                            LightListing.version
                        );
                        this.toggleAddingAnotherPiece(true);
                    }}
                >
                    <i className="icon blue pos-abs" /> Add more jewelry
                </button>
            );

            ADDING_ANOTHER_PIECE_DROPDOWN = (
                <DropDown
                    overrideCSS={{
                        textAlign: "left",
                        minWidth: this.isMobile ? "0" : "283px",
                        marginRight: this.isMobile ? "0" : "30px",
                    }}
                    change={(itemType) => {
                        this.setState({ itemToBeAddedType: itemType });
                    }}
                    placeholder={"Type of jewelry"}
                    overrideWrapperCSS={{
                        marginBottom: this.isMobile ? "12px" : "18px",
                    }}
                    disabled={false}
                    value={itemToBeAddedType}
                    dataAutomation="add-another-piece"
                >
                    {Object.keys(ItemTypesPlural)
                        .filter(
                            (option) =>
                                !["Jewelry Box", "Other"].includes(option)
                        )
                        .map((option) => (
                            <DropItem
                                key={option}
                                label={option}
                                value={ItemTypesPlural[option]}
                            />
                        ))}
                </DropDown>
            );

            ADD_ANOTHER_PIECE = (
                <>
                    {!hideAddAnotherPieceButton && ADDING_ANOTHER_PIECE_BUTTON}
                    {showAddingAnotherPieceForm && (
                        <>
                            <i
                                onClick={() =>
                                    this.toggleAddingAnotherPiece(false)
                                }
                                className={"another-piece-overlay pos-fix"}
                            />
                            <form
                                onSubmit={(e) => e.preventDefault()}
                                className={`another-piece-form pos-rel ${
                                    addInProgress && "disabled"
                                }`}
                            >
                                <section
                                    className={
                                        "pane-listing item-details-light-listing"
                                    }
                                >
                                    <span className="item-upper-caption item-upper-caption-temp">
                                        #--
                                    </span>
                                    <h1 className="item-name continue-button-wrapper">
                                        {ADDING_ANOTHER_PIECE_DROPDOWN}
                                        {itemToBeAddedType && (
                                            <MediumPrimaryButton
                                                text="Add"
                                                overrideCSS={{
                                                    width: "66px",
                                                    minWidth: "66px",
                                                    marginRight: "10px",
                                                    marginTop: "9px",
                                                    padding: "9px 16px",
                                                }}
                                                click={
                                                    this
                                                        .addAnotherPieceExpAdding
                                                }
                                            />
                                        )}
                                        {itemToBeAddedType && (
                                            <MediumLinkButton
                                                text="Cancel"
                                                overrideCSS={{
                                                    minWidth: "66px",
                                                    padding: "9px 16px",
                                                    marginTop: "9px",
                                                }}
                                                click={
                                                    this
                                                        .addAnotherPieceExpCancelling
                                                }
                                            />
                                        )}
                                    </h1>
                                    <ul
                                        className={`item-details-list same-line disabled ${
                                            this.isMobile && "hide"
                                        }`}
                                    >
                                        <li className="item-details-list-item">
                                            <span className="item-fact-title">
                                                {I18n.getString(
                                                    "listingPageLight::itemDetails::photos"
                                                )}
                                            </span>
                                            {
                                                // all photos
                                                <div className="d-flex ">
                                                    <span className="upload-photo-link cursor-default">
                                                        <span
                                                            className="add-a-photo"
                                                            onClick={() => {
                                                                this.toUploadPhotos(
                                                                    item.id,
                                                                    "add"
                                                                );
                                                            }}
                                                        >
                                                            <img
                                                                className="camera-image-link"
                                                                src={imageUrl(
                                                                    "common/cameraPlusBlue.svg"
                                                                )}
                                                            />{" "}
                                                            Add
                                                        </span>
                                                    </span>
                                                    <BlackBox
                                                        data-automation={dataAutomationAttr(
                                                            "studio-photos-black-box"
                                                        )}
                                                        onClickMe={() => {}}
                                                        caption="Studio photos"
                                                    />
                                                </div>
                                            }
                                        </li>
                                        <li className="item-details-list-item lab-report">
                                            <span className="item-fact-title">
                                                {I18n.getString(
                                                    "listingPageLight::itemDetails::labReport"
                                                )}
                                            </span>
                                            <BlackBox
                                                data-automation={dataAutomationAttr(
                                                    "lab-report-black-box"
                                                )}
                                                onClickMe={() => {}}
                                                caption={I18n.getString(
                                                    "listingPageLight::itemDetails::tbd"
                                                )}
                                            />
                                        </li>
                                    </ul>
                                </section>
                            </form>
                        </>
                    )}
                </>
            );

            let isWatchDisabled = false;
            const photoState = ["quick-sale", "approve", "auction"];
            if (item.item_type === "watch") {
                isWatchDisabled =
                    item.workflow_state === VALIDATION_NEEDED ||
                    !photoState.includes(item.photo_validation_review);
            }

            const disableSetUpShipment =
                _.get(item, "submission_qualification", false) ||
                isWatchDisabled;

            const itemAppointment = _.get(appointment, "scheduledTime", "");
            const infoCallAlter = () =>
                `Your call was scheduled to ${itemAppointment}`;

            return (
                <>
                    <div>
                        {openCompleteAccountModal
                            ? ListingAlerts.completeAccountModal(
                                  this.props,
                                  LightListing.version,
                                  this.shouldOpenCompleteAccountModal,
                                  UserActions.lightListingPage
                              )
                            : null}
                    </div>
                    <Grid
                        className={`light-listing light-listing_top-section`}
                        container
                        spacing={0}
                    >
                        {certificateUpdateAlert && (
                            <CertificateAlert
                                variant={certificateUpdateAlert}
                                onClose={() => {
                                    this.setState({
                                        certificateUpdateAlert: null,
                                    });
                                }}
                            />
                        )}
                        {itemAppointment ? (
                            <SuccessAlert
                                overrideCSS={{
                                    textAlign: "left",
                                    fontSize: "16px",
                                    color: "white",
                                    backgroundColor: "#47566D",
                                    svg: { fill: "white" },
                                }}
                                overrideWrapperCSS={{
                                    width: "100%",
                                    margin: "25px 0 15px",
                                }}
                                canClose={true}
                                closing={true}
                                TextComponent={infoCallAlter}
                                onClose={() => {}}
                            />
                        ) : null}
                        {!disableSetUpShipment ? (
                            <ListingAlerts
                                isMobile={this.isMobile}
                                itemId={this.props.params.itemId}
                                userActionsCb={UserActions.lightListingPage}
                                shouldOpenCompleteAccountModal={
                                    this.shouldOpenCompleteAccountModal
                                }
                                openSchedulePickupForm={
                                    this.isMobile
                                        ? this.openSSSForMobile
                                        : this.openSSSForDesktop
                                }
                                version={LightListing.version}
                            />
                        ) : null}
                        <div className="light-listing-main-title">
                            <h3>
                                {item.shipment &&
                                item.shipment.shipment_method ===
                                    SHIPMENT_METHOD["In-Person Drop Off"]
                                    ? "Review before In-Person Appointment"
                                    : I18n.getString(`listingPage::title`)}
                            </h3>
                        </div>
                        {item.shipment ? (
                            this.isMobile ? (
                                this.renderShipmentInformation(item)
                            ) : null
                        ) : (
                            <div className="text-center light-listing-subtitle-wrap">
                                <h4 className="light-listing-subtitle">
                                    {I18n.getString(
                                        `listingPageLight::subtitle`
                                    )}
                                </h4>
                            </div>
                        )}
                    </Grid>
                    {this.isMobile ? (
                        hideAddAnotherPieceButton ? null : (
                            COMPONENTS_FLOW_MOBILE[0]
                        )
                    ) : (
                        <div className={"light-listing"}>
                            <Grid container spacing={24}>
                                <Grid item xs={8}>
                                    {item.shipment
                                        ? this.renderShipmentInformation(item)
                                        : null}
                                    {ITEM_DETAILS_SECTION}
                                    {ADDITIONAL_ITEMS &&
                                        ADDITIONAL_ITEMS.length > 0 && (
                                            <ul
                                                className={
                                                    "secondary-items-list"
                                                }
                                            >
                                                {ADDITIONAL_ITEMS.map((i) => {
                                                    return (
                                                        <AdditionalItemDetails
                                                            key={`addition-item-${i.id}`}
                                                            logger={
                                                                this.logAction
                                                            }
                                                            clickOnBox={
                                                                item.workflow_state ===
                                                                SHIPPING
                                                                    ? () => {}
                                                                    : this
                                                                          .openExtraInfoSlider
                                                            }
                                                            item={i}
                                                            parentItemId={
                                                                this.props
                                                                    .params
                                                                    ?.itemId
                                                                    ? this.props
                                                                          .params
                                                                          ?.itemId
                                                                    : window.location.pathname.replace(
                                                                          /\D/g,
                                                                          ""
                                                                      )
                                                            }
                                                            version={version}
                                                            onDataChange={() =>
                                                                this.getItemInfo()
                                                            }
                                                        />
                                                    );
                                                })}
                                            </ul>
                                        )}
                                    {ADD_ANOTHER_PIECE}
                                </Grid>
                                <Grid item xs={4}>
                                    {" "}
                                    {UP_NEXT_SECTION}{" "}
                                </Grid>
                            </Grid>
                        </div>
                    )}
                    {this.isMobile && (
                        <Grid className={`light-listing`} container spacing={0}>
                            <div className="add-another-piece-component">
                                {showAddingAnotherPieceForm && (
                                    <i
                                        onClick={() =>
                                            this.toggleAddingAnotherPiece(false)
                                        }
                                        className={
                                            "another-piece-overlay pos-fix"
                                        }
                                    />
                                )}
                                {hideAddAnotherPieceButton
                                    ? null
                                    : ADD_ANOTHER_PIECE}
                            </div>
                        </Grid>
                    )}
                    {this.isMobile && COMPONENTS_FLOW_MOBILE[1]}
                    {this.isMobile &&
                        hideAddAnotherPieceButton &&
                        COMPONENTS_FLOW_MOBILE[0]}
                    <div>
                        <div className="light-listing light-listing-footer full-width">
                            <ExtraInfo
                                item={item}
                                openSlide={openSlide}
                                version={version}
                                openSlideViaParent={this.openExtraInfoSlider}
                                closeSlide={this.closeExtraInfoSlider}
                            />
                        </div>
                    </div>
                </>
            );
        } else return <ListingSkeleton />;
    }
}

const mapStateToProps = ({
    ADO,
    Item,
    Session,
    Experiments,
    Personalized,
    ScheduleAppointment,
}) => {
    return {
        item: Item,
        ADO,
        Session,
        experiments: Experiments,
        P13N: Personalized,
        appointment: ScheduleAppointment,
    };
};

const mapDispatchToProps = (dispatch) => {
    const boundActions = bindActionCreators(
        {
            getItem,
            addAnotherPiece,
            acceptItemEstimation,
            appointmentsItemDetails,
        },
        dispatch
    );
    return {
        updateItem: delayedItemUpdate(dispatch),
        ...boundActions,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LightListing);
